import React from "react";
import Select from "./Select.tsx";
import selectTokens from "./selectTokens.ts";

/**
 * Селект‑фильтр: ширина 100 %, высота 48 px, радиус 8 px
 */
const SelectFilter = (props) => {
  const t = selectTokens.sizes.F;
  return (
    <Select
      {...props}
      size="F"                       // передаём новый размер
      style={{ width: "100%" }}
      radius="filter"           
    />
  );
};

export default SelectFilter;